// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://selfcareadminbackend.americanholdings.lk",
  withCredentials: true,
});

// Attach Authorization header if token exists
const attachAuthHeader = (config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
};

// Request interceptors
api.interceptors.request.use(attachAuthHeader);
axios.interceptors.request.use(attachAuthHeader);

// Response interceptor to auto-logout on 401/403
const handleAuthError = (error) => {
  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    try {
      localStorage.removeItem("authToken");
    } catch (_) {}
    // For HashRouter, navigate to root
    if (typeof window !== "undefined") {
      window.location.hash = "/";
    }
  }
  return Promise.reject(error);
};

api.interceptors.response.use((r) => r, handleAuthError);
axios.interceptors.response.use((r) => r, handleAuthError);

export default api;
